import TransitionLine from '../../assets/images/Transition/TransitionLine';
import TransitionBg from '../../assets/images/Transition/TransitionBg';
import { ImageBackground, ImageContainer, ImageLine, MainContainer, TransitionText } from './TransitionStyledComponent';
// import TransitionBackground from '../../assets/images/Transition/transitionBackground.svg';
// import { ImageBackground, ImageContainer, ImageLine, MainContainer, TransitionText } from './TransitionStyledComponent';

export const Transition = () => {

    return (
        <>
            <MainContainer id='loading-page'>
                <TransitionText id='loading-title'>Unos segundos y casi estamos</TransitionText>
                <ImageContainer>
                <ImageLine>
                    <TransitionLine />
                </ImageLine>
                <ImageBackground>
                    <TransitionBg />
                </ImageBackground>
                </ImageContainer>
            </MainContainer>
        </>
    );
};